import {ResolveFn} from "@angular/router";
import {inject} from "@angular/core";
import {Store} from "@ngrx/store";
import {TechInventoryActions} from "@tech/pages/inventory/store/tech-inventory.actions-type";
import {of} from "rxjs";

export const techInventoryResourceDetailResolver: ResolveFn<null> = (route, state) => {
  const store = inject(Store);
  const resourceId = route.paramMap.get('resourceId');

  if (resourceId) {
    const urlSegments = state.url.split('/');
    const idIndex = urlSegments.findIndex(segment => segment === resourceId);
    const existingUrl = idIndex !== -1
      ? urlSegments.slice(idIndex + 1)
      : [];

    store.dispatch(TechInventoryActions.getResourceDetailById({
      resourceId,
      existingUrl
    }));
  }

  return of(null);
};
